import mapboxgl from 'mapbox-gl'

export default {
    props: {
        hasMarker: {
            type: Boolean,
            default: false
        },
        markerCoordinates: {
            type: Array,
            default: function () {
                return [135, 35]
            }
        },
        draggable: {
            type: Boolean,
            default: false
        },
        isParcelForm: {
            type: Boolean,
            default: false
        },
        markerSource: {
            type: Array,
            default: function () {
                return null;
            }
        },
        mapData: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    data() {
        return {
            myMarker: null
        }
    },
    methods: {
        handleMarker() {
            if (!this.hasMarker) return;
            if (this.myMarker) {
                this.removeMarker()
            }

            var markerElement = '';
            if (this.markerSource && this.markerSource[0]) {
                var bubbleDiv = document.createElement('div');
                bubbleDiv.className = 'rounded-full p-1 illustration-marker'
                bubbleDiv.innerHTML = `<span loading="lazy" class="bg-cover marker-size" style=""> </span>`;

                this.mySmartMap.on('render', () => {
                    this.getMarkerElement(bubbleDiv);
                    this.handleRotateMarker();
                });
                this.setFlyToForMarker(this.markerCoordinates);
                var markerElement = document.createElement('div');
                markerElement.id = 'spot-sample';
                markerElement.appendChild(bubbleDiv);
            }
            this.myMarker = new mapboxgl.Marker({
                element: markerElement,
                draggable: this.draggable
            })
                .setLngLat(this.markerCoordinates)
                .addTo(this.mySmartMap)

            if (this.markerSource && this.markerSource[0]) {
                this.myMarker.setRotation(-this.mySmartMap.getBearing());
            }
            this.myMarker.on('dragend', this.onDragEnd)
        },
        onDragEnd() {
            var lnglat = this.myMarker.getLngLat();
            if (!this.isParcelForm) {
                this.$emit('updatedMarkerCoordinates', [lnglat.lng, lnglat.lat])
            } else {
                this.updateCoordinates([lnglat.lng, lnglat.lat]);
            }
        },
        removeMarker() {
            this.myMarker.remove()
        },
        queryLocation(address) {
            if (!address) return;
            let self = this

            axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                params: {
                    address: address,
                    key: 'AIzaSyCPziEsEJY2tHTnQWulQhvly1V_AalefhE'
                },
                headers: '',
              })
              .then(function (response) {
                if (response.data.results.length > 0) {
                    let coordinates = response.data.results[0].geometry.location;
                    self.$emit('updatedMarkerCoordinates', [coordinates.lng, coordinates.lat])
                    self.setFlyToForMarker([coordinates.lng, coordinates.lat])
                }
              })
        },
        setFlyToForMarker(val) {
            this.mySmartMap.flyTo({
                center: val,
                speed: 1.8
            })
        },
        getMarkerElement(bubbleDiv) {
            var currentVal = this.mySmartMap.getZoom();
            var originalZoomLevel = this.mapData.zoom_level;
            var perOfWidth = this.markerSource[0] ? parseInt(this.markerSource[1])/100 : 1;
            var spanWidth = this.markerSource[3] ? this.markerSource[3] * perOfWidth : 44;
            var spanHeight = this.markerSource[4] ? this.markerSource[4] * perOfWidth : 44;
            var scale = Math.pow(2, (currentVal - originalZoomLevel));
            var spanElement = bubbleDiv.querySelector('span');
            spanElement.style.cssText = this.markerSource[2];
            spanElement.style.backgroundImage = this.markerSource[0] ? `url(${this.markerSource[0]})` : '';
            spanElement.style.width = spanWidth * scale + 'px';
            spanElement.style.height = spanHeight * scale + 'px';
            spanElement.style.display = 'inline-block';
            spanElement.style.backgroundSize = 'cover';
            spanElement.style.position = 'relative';
            bubbleDiv.style.transform = `rotate(${this.bearing}deg)`;
        },
        handleRotateMarker() {
            var spotElement = document.getElementById('spot-sample');
            if (spotElement == null) return;
            var oldTransform = spotElement.style.transform;
            let regex = /rotateZ(.*?)deg\)/;
            let rotateZ = -this.mySmartMap.getBearing();
            if (regex.test(oldTransform)) {
                var newTransform = oldTransform.replace(regex, `rotateZ(${rotateZ}deg)`);
            } else {
                var newTransform = `${oldTransform} rotateZ(${rotateZ}deg)`;
            }
            spotElement.style.transform = newTransform;
        }
    },
    watch: {
        hasMarker() {
            this.handleMarker()
        },
        draggable(newVal) {
            this.myMarker.setDraggable(newVal)
        },
        markerCoordinates(newVal) {
            if (!this.myMarker) {
                this.handleMarker()
            } else {
                this.myMarker.setLngLat(newVal)
            }
        },
        markerSource() {
            var spotElement = document.getElementById('spot-sample');
            if (this.markerSource && this.markerSource[0] && spotElement) {
                var bubbleDiv = spotElement.querySelector('div');
                this.getMarkerElement(bubbleDiv);
            } else {
                this.handleMarker();
            }
        }
    }
}